import React, {useEffect, useState} from "react";
import {styled, useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Footer from "./Footer";
import {playersService} from "../../services";
import SideBar from "./SideBar";
import {useDispatch, useSelector} from "react-redux";
import {playingStatus} from "../../reducers/players/playersSlice";
import Link from "@mui/material/Link";
import {useTranslation} from "react-i18next";

const PREFIX = "ImageElement";

const classes = {
  imageContainer: `${PREFIX}-imageContainer`,
  image: `${PREFIX}-image`,
  title: `${PREFIX}-title`,
  elementDescriptiontt: `${PREFIX}-elementDescriptiontt`,
  elementDescriptionin: `${PREFIX}-elementDescriptionin`,
};

const Root = styled("div")(({theme}) => ({
  [`&.${classes.imageContainer}`]: {
    position: "relative",
    backgroundColor: "black",
    width: "100%",
    height: "100%",
    scrollSnapAlign: "start",
    zIndex: "90",
  },

  [`& .${classes.image}`]: {
    backgroundColor: "black",
    height: "100%",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      objectFit: "contain",
    },
    // objectFit: 'cover',
    objectFit: "contain",
    // objectPosition: 'top',
  },

  [`& .${classes.title}`]: {
    textAlign: "center",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "90%",
    position: "absolute",
    top: "0",
    left: "50%",
    transform: "translateX(-50%)",
  },
  [`& .${classes.elementDescriptiontt}`]: {
    width: "95%",
    color: "white",
    position: "absolute",
    bottom: "10px",
    left: "50%",
    transform: "translateX(-50%)",
    textAlign: "center",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxHeight: "32px",
    zIndex: "15",
  },
  [`& .${classes.elementDescriptionin}`]: {
    width: "73%",
    color: "white",
    position: "absolute",
    bottom: "4rem",
    left: "50%",
    transform: "translateX(-50%)",
    textAlign: "center",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxHeight: "32px",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
  },
}));

const ImageElement = ({url, token, verticalPlayer, isActive, myVideoTag}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const currentElement = useSelector(
    (state) => state.players.playlist[state.players.currentPlayingIndex]
  );
  const firstTime = useSelector((state) => state.players.firstTime);
  const [once, setOnce] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handleOpenLink = () => {
    if (isMobile) {
      // Sur mobile, ouvrir dans un nouvel onglet
      window.open(currentElement.imageLink, '_blank');
    } else {
      // Sur desktop, ouvrir dans une popup centrée
      const width = 1200;
      const height = 800;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;
      window.open(
        currentElement.imageLink,
        '_blank',
        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
      );
    }
  };

  useEffect(() => {
    if (isActive && !firstTime) dispatch(playingStatus(true));
    if (isActive && myVideoTag) myVideoTag.pause();
  }, [isActive, firstTime, dispatch, myVideoTag]);

  useEffect(() => {
    if (isActive) {
      if (!once) {
        playersService.playerContentSeen(token, currentElement.id);
      }
      setOnce(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);

  return (
    <Root className={classes.imageContainer}>
      <img
        src={url}
        alt={`${currentElement.pushedBy?.login || "pushed by someone"}`}
        // ref={imageRef}
        className={classes.image}
      />
      {currentElement.imageLink && (
        <Link
          href={currentElement.imageLink}
          target="_blank"
            style={{
              minWidth: '120px',
              textAlign: 'center',
              position: "absolute",
              left: '50%',
              top: '50%',
              zIndex: 9999,
              transform: 'translate(-50%, -50%)',
              backgroundColor: "rgb(181 154 79 / 90%)",
              color: 'white',
              padding: '8px 16px',
              borderRadius: '4px',
              textDecoration: 'none',
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
              textTransform: 'uppercase',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              lineHeight: 1.75,
              letterSpacing: '0.02857em',
              boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
            }}>
            {t("player.buttons.visitCustomWatermarkButton")}
        </Link>
      )}
      <Footer verticalPlayer={verticalPlayer}/>
      <SideBar token={token} verticalPlayer={verticalPlayer} />
    </Root>
  );
};
export default ImageElement;
